import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { MaskedLines, Reveal } from '@/components/Reveal';

const PageHero = ({ eyebrow, title, description, crumb }) => (
  <section className="relative overflow-hidden bg-navy text-cream noise-overlay">
    <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full border-[24px] border-gold/10" aria-hidden="true" />
    <div className="absolute -left-16 bottom-0 h-48 w-48 rounded-full border-[18px] border-crimson/20" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
      <Reveal>
        <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-gold">
          <Link to="/" className="text-cream/50 hover:text-gold transition-colors" data-testid="breadcrumb-home">Home</Link>
          <ChevronRight className="h-3 w-3 text-cream/30" />
          {crumb || eyebrow}
        </p>
      </Reveal>
      <MaskedLines
        lines={[title]}
        className="mt-5"
        lineClassName="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight"
      />
      {description && (
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-cream/70 leading-relaxed">{description}</p>
        </Reveal>
      )}
    </div>
  </section>
);

export default PageHero;
